<script setup lang="ts">
import { useI18n } from 'vue-i18n';
import type { Locales, ProjectModuleDto } from '@/services/types/api.types';
import { useConfigurationStore } from '@/stores/configurations.store';
import LocalizedEditor from '@/components/base/LocalizedEditor.vue';
import LocalizedInput from '../LocalizedInput.vue';
import StandardToggle from '../StandardToggle.vue';

const { t } = useI18n();
const isProjectTOCEnabled = useConfigurationStore().isFeatureEnabled('projectTOC');

const props = defineProps<{
  languageEnabled: Locales[];
  editLocale: Locales;
  module: ProjectModuleDto;
}>();
</script>

<template>
  <div class="module-document-submission">
    <localized-input
      name="title"
      :label="t('global.label.title')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <q-field :label="t('global.label.description')" stack-label borderless>
      <template v-slot:control>
        <localized-editor
          name="config.description"
          :label="t('global.label.description')"
          class="q-mt-sm full-width"
          :editLocale="editLocale"
          :language_enabled="props.languageEnabled"
        />
      </template>
    </q-field>
    <localized-input
      name="config.submitButtonLabel"
      :label="t('project-module.documentSubmission.submitButtonLabel')"
      :editLocale="editLocale"
      outlined
      :language_enabled="props.languageEnabled"
    />
    <q-field :label="t('global.label.thank-you-message')" stack-label borderless>
      <template v-slot:control>
        <localized-editor
          name="config.thankYouMessage"
          :label="t('global.label.thank-you-message')"
          class="q-mt-sm full-width"
          :editLocale="editLocale"
          :language_enabled="props.languageEnabled"
        />
      </template>
    </q-field>
    <standard-toggle name="config.highlight" :label="t('project-module.admin.highlight')" outlined />
    <standard-toggle
      v-if="isProjectTOCEnabled"
      name="config.includeInTableOfContents"
      :label="t('project-module.admin.includeInTableOfContents')"
      outlined
    />
  </div>
</template>
